import React, { useEffect, useState } from "react";
import Axios from "axios";
import TextField from "@mui/material/TextField";
import Navbar from "./Navbar";
import { useHistory } from "react-router-dom";
import Loading from "./Components/Loading";
import { message } from "antd";

function AddSource() {
  const history = useHistory();
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const [source, setSource] = useState("");
  const [sourceError, setSourceError] = useState(false);

  /*eslint-disable */
  const [loading, setLoading] = useState(false);
  /*eslint-enable */

  useEffect(() => {
    document.title = "Add Source";
  }, []);

  const addToList = () => {
    setDescriptionError(false);
    setSourceError(false);

    if (source === "") {
      setSourceError(true);
      return;
    }

    if (description === "") {
      setDescriptionError(true);
      return;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    Axios.post(
      "/api/source/insertSource",
      {
        SourceName: source,
        Description: description,
      },
      config
    )
      .then(function (response) {
        message.success(" Added successfully");
        setTimeout(function () {
          history.push("/sourcelist");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  return (
    <>
      {loading && <Loading />}
      <Navbar title="Add Source" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          style={{
            paddingLeft: "20px",
            paddingBottom: "10px",
            fontSize: "25px",
          }}
        >
          {/* <h2>Add Source</h2> */}
        </div>
        <div className="row mt-3 mb-4 pr-3 pl-3">
          <div className="col-lg-12">
            <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
              <div className="card-body">
                <div className="row form-group  " style={{ padding: "10px" }}>
                  <div className="col-lg-6">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Source Name"
                      onChange={(e) => setSource(e.target.value)}
                      error={sourceError}
                    />
                  </div>

                  <div className="col-lg-6">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Description"
                      onChange={(e) => setDescription(e.target.value)}
                      error={descriptionError}
                    />
                  </div>
                </div>

                <div
                  className="float-right pr-3"
                  style={{ paddingTop: "40px" }}
                >
                  {" "}
                  <button
                    onClick={addToList}
                    className="btn btn-primary add-button  "
                  >
                    {" "}
                    Add Source{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSource;
